/**
 * @file BootPerformance.ts
 * @role Emits stable, read-only performance marks for bundled boot measurement.
 * @owns Safe access to the optional Performance.mark browser API.
 * @neverDoes Measure durations itself or affect boot control flow.
 */
/**
 * Note on `game:interactive`: on a touch device's FIRST session it also spans the fullscreen
 * consent modal, which waits on a human. Treat mobile first-session boot times as including
 * decision time — they are not comparable with desktop or with returning-player sessions.
 * See src/app/FullscreenConsent.ts.
 */
export type BootPerformanceMark = 'boot:start' | 'splash:visible' | 'game:interactive';

export function markBootPerformance(name: BootPerformanceMark): void {
  if (typeof performance === 'undefined' || typeof performance.mark !== 'function') return;
  performance.mark(name);
}
